import { ClientConfigProductName } from '@frontend/vanilla/core';

export const GeoLocationAssetLoader = {
    id: 'geo-location-asset',
    loaderFn: () => import(/* webpackChunkName: "ms-geo-location-asset-loader" */ './geo-location.feature'),
    product: ClientConfigProductName.SPORTS,
};
